<script lang="ts">
  import { onMount } from "svelte";
  import { injectAuditLogCss } from "../lib/gruimModuleTheme";

  let el1: HTMLDivElement;

  const formatDateTime = (value: unknown): string => {
    const raw = String(value ?? "");
    if (!raw) return "";

    const parsed = new Date(raw);
    return Number.isNaN(parsed.getTime()) ? raw : parsed.toLocaleString();
  };

  const mountGrappleAuditLog = async (): Promise<void> => {
    try {
      const { default: GrappleAuditLog } = await import("App/GrappleAuditLog");

      if (el1) {
        el1.innerHTML = "";
        new GrappleAuditLog({
          target: el1,
          props: {
            translation: {
              actedAt: "Acted At",
              actedOn: "Acted On",
              actionKey: "Action Key",
              entityId: "Entity ID",
              before: "Before",
              after: "After",
            },
            schema: {
              visibility: {
                readOnly: true,
              },
              "field-properties": {
                "auto-generated-fields": ["id"],
                "field-order": [
                  "actedAt",
                  "actor",
                  "action",
                  "actedOn",
                  "actionKey",
                  "entityId",
                  "before",
                  "after",
                ],
                "field-transformation": [
                  {
                    name: "actedAt",
                    transformation: (value: unknown) => formatDateTime(value),
                  },
                ],
              },
            },
          },
        });
      }
    } catch (err) {
      console.warn("GrappleAuditLog module unavailable:", err);
    }
  };

  onMount(async () => {
    injectAuditLogCss();
    await mountGrappleAuditLog();
  });
</script>

<div class="audit-log-dark" bind:this={el1} />
